import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, House } from "lucide-react";
export default function Hero() {
  return;
}